var _path, _g, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 199,
    viewBox: "0 0 210 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 190.5H8.72514L77.9565 8.5H201.5V190.5Z",
    stroke: "#7B3BCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_151_5979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201 190H9.4503L78.3013 9H201V190Z",
    stroke: "#6F00FF",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_151_5979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201 190H9.4503L78.3013 9H201V190Z",
    stroke: "#6F00FF",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201 190H9.4503L78.3013 9H201V190Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_151_5979",
    x: 0.7,
    y: 0.7,
    width: 208.6,
    height: 197.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.65,
    result: "effect1_foregroundBlur_151_5979"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_151_5979",
    x: 0.7,
    y: 0.7,
    width: 208.6,
    height: 197.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.65,
    result: "effect1_foregroundBlur_151_5979"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBox);
export default __webpack_public_path__ + "static/media/RightBox.844a87b3e71dc5181768aca1d38beea4.svg";
export { ForwardRef as ReactComponent };